



















import {Vue, Prop , Component} from 'vue-property-decorator';
import * as $ from 'jquery';
import * as enterpriseFromService from '@/store/Services/enterpriseFormService.ts';
import  store from '@/store';
import { EnterpriseForm } from '../../../store/models/EnterpriseForm/EnterpriseForm';
@Component
export default class QuickAccessMobile extends Vue{
    enterpriseForms = [] as EnterpriseForm[];
    formSearchTxt = '';
    isFirstClickDone = false;
    ownerId = '';
    isLoading = false;
    get filteredForms(){
        return this.enterpriseForms.filter(x=>x.name.includes(this.formSearchTxt));
    }
    fastSend(mode: string){
        this.$emit('fast-send-clicked',mode);
    }
    
    mounted(){
        $('.popup').popup();
        $('#test').dropdown();
        $('a.browse.item').popup({
            popup : $('.ui.flowing.basic.admission.popup'),//Popup Content selector 
            on    : 'click',//event trigger
            position   : 'bottom left',
            lastResort:true,
        })
    }

    onFormsIconClicked(){
        
        this.$emit('shallShowenterpriseFormListsEvent');
        this.ownerId =  store.state.ownerId;
        store.state.eventHub.$emit('shallLoadEnterpriseFormListsEvent',this.ownerId);

    }


}
